import request from '@/modules/base/util/request'
import config from '@/modules/settings/config'

export const DeliveryConditionService = {
  getAll: () => {
    return new Promise((resolve, reject) => {
      request(config.deliveryConditions, {
        method: 'GET',
        auth: true,
        isConcurrent: true,
      })
        .then(response => {
          const { body: { data } } = response
          resolve(data)
        })
        .catch(error => reject(error))
    })
  },
  getById: (id) => {
    return new Promise((resolve, reject) => {
      request(`${config.deliveryConditions}/${id}`, {
        method: 'GET',
        auth: true,
        isConcurrent: true,
      })
        .then(response => {
          const { body: { data } } = response
          resolve(data)
        })
        .catch(error => reject(error))
    })
  },
}
